// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-webmention-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.c-webmention-list__item + .c-webmention-list__item {\n    margin-top: 32px\n}\n@media (min-width: 40em) {\n.c-webmention-list__item + .c-webmention-list__item {\n      margin-top: 48px\n}\n}\n", ""]);
// Exports
module.exports = exports;
